import { type Condition, ConditionOperatorEnum } from '@repo/api-gw-sdk';

import type { FilterProperty } from '@/types/advanceFilter';

export interface ConditionEditorOptions {
  supportGrouping?: boolean;
  allowUsingProperty?: (property: FilterProperty) => boolean;
  supportedProperties: FilterProperty[][];
}

export interface LocationIndicator {
  index: number;
  location: 'above' | 'below';
}

export function isGroup(condition: Condition) {
  return (
    condition?.operator === ConditionOperatorEnum.And ||
    condition?.operator === ConditionOperatorEnum.Or
  );
}
